<div class="gis-bids-page">
  <h2 class="gis-bids-region-path">{{ regionPathDisplay }}</h2>
  <div class="gis-bids-map-wrapper">
    <div class="fields-summary-header">
      <span>{{ 'Number of bids' | translate }}: <strong>{{ totalCount }}</strong></span>
    </div>
    <app-openstreetmap
      [mapController$]="mapController$"
      [mapOptions]="mapOptions"
      (mapReady)="onMapReady()"
      class="gis-bids-map"
    ></app-openstreetmap>
  </div>
</div>
